const feed_es = require('./feed.json')
export default feed_es